import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
const today = new Date().toISOString().split('T')[0];

function PendingRequest() {
  const [currentDate, setCurrentDate] = useState('');
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const handleSearch = async (e) => {
    e.preventDefault();
    const { start_date, end_date } = e.target;
    let rechargeData = {
      user_id: userId,
      start_date: start_date.value,
      end_date: end_date.value,
    };
    getData(rechargeData);
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      user_id: pageData.user_id,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/getPendingRequest", requestData);
      const { status, data, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const Refresh = async (data) => {
    try {
      let requestData = {
        id: data._id,
        txnid: data.txnid,
        user_id: data.user_id
      };
      const response = await axios.post("/reports/check/add/money/pending/request", requestData);
      const { status, message } = response.data;
      document.querySelector(".search-btn").click();
      if (status) {
        swal("Success", message, "success");
      }
      else {
        swal("Error", message, "error");
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setCurrentDate(today);
  }, []);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserId("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Pending Request Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />
                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserId(item._id);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" value={currentDate} max={today} onChange={(e) => setCurrentDate(e.target.value)} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Pending Request History
                    </h4>
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="full_name"
                        header="User(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="User">{rowData?.firstname}<br />({rowData?.phone})</span>}
                      />
                      <Column
                        field="txnid"
                        header="Transaction ID"
                        sortable
                        body={(rowData) => <span data-label="TransactionID">{rowData.txnid}</span>}
                      />
                      <Column
                        field="dob"
                        header="PayuID"
                        sortable
                        body={(rowData) => <span data-label="PayuID">{rowData?.payuId}</span>}
                      />
                      <Column
                        field="amount"
                        header="Amount"
                        sortable
                        body={(rowData) => <span data-label="Amount">{parseFloat(rowData.amount).toFixed(2)}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData.status}</span>}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <button className="btn btn-primary" onClick={(e) => Refresh(rowData)}>Refresh</button>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PendingRequest;
